/**
 * SO 明細／配置：新契約欄位讀取（含舊名 fallback）。
 */

export function getSalesOrderLineQty(line) {
  return line?.qty ?? line?.shipQty;
}

export function getSalesOrderLineMtrs(line) {
  if (Array.isArray(line?.mtrs)) {
    return line.mtrs;
  }
  if (Array.isArray(line?.materials)) {
    return line.materials;
  }
  return [];
}

export function getSalesOrderLineInvAllocations(line) {
  if (Array.isArray(line?.invAllocations)) {
    return line.invAllocations;
  }
  if (Array.isArray(line?.inventoryAllocations)) {
    return line.inventoryAllocations;
  }
  return [];
}

export function getSalesOrderAllocationMtrId(allocation) {
  return allocation?.salesOrderLineMtrId
    ?? allocation?.customerOrderMaterialSnapshotId
    ?? null;
}

export function getSalesOrderAllocationStockId(allocation) {
  return allocation?.invStockId
    ?? allocation?.inventoryStockId
    ?? null;
}

export function getSalesOrderTaxMode(detailOrValues) {
  return detailOrValues?.taxMode ?? detailOrValues?.priceTaxMode ?? null;
}
